import React from "react";
import {ReactComponent as icon} from "assets/img/brand_icons/Instagram.svg";

export const IconInstagram = () => React.createElement(icon);
